export default __webpack_public_path__ + "static/media/planet-1.b1a15bae.svg";